module.exports = __webpack_public_path__ + "static/TranslatorInExtension@2x-7a1e5d9bfecde9019062ccd4fbea2e73.png";